import { RouterProvider, createBrowserRouter } from "react-router-dom";

import DefaultLayout from "containers/defaultLayout";
import NotFound from "pages/NotFound";
import Main from "pages/main";
import NoticeNews from "pages/board/noticeNews";
import Notice from "pages/board/notice";
import NoticeView from "pages/board/noticeView";
import Location from "pages/company/location";  
import Manufacture from "pages/company/manufacture";
import History from "pages/company/history";
import Introduction from "pages/company/introduction";
import B2B from "pages/distribution/b2b";
import Partners from "pages/distribution/partners";
import Proposal from "pages/distribution/proposal";

import Global from "pages/business/global";
import ProposalOversea from "pages/business/proposal_oversea";

import Research from "pages/research/research";
import Qc from "pages/research/qc";
import Qs from "pages/research/qs";

import Brand from "pages/brand/brand";
import Representative from "pages/brand/representative";
import Channel from "pages/brand/channel";
import Store from "pages/brand/store";

import {goToLocation} from 'assets/js/commonUtil';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/grid';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

function App() {
  const router = createBrowserRouter([
    {
      path: '/',
      element: <DefaultLayout />,
      errorElement: <NotFound />,
      children: [
        { index: true, element: <Main /> },
        { path: '/introduction', element: <Introduction /> },
        { path: '/history', element: <History /> },
        { path: '/manufacture', element: <Manufacture /> },
        { path: '/location', element: <Location /> },
        
        { path: '/b2b', element: <B2B /> },
        { path: '/partners', element: <Partners /> },
        { path: '/proposal', element: <Proposal /> },

        { path: '/research', element: <Research /> },
        { path: '/qc', element: <Qc /> },
        { path: '/qs', element: <Qs /> },

        { path: '/channel', element: <Channel /> },
        { path: '/store', element: <Store /> },
        { path: '/global', element: <Global /> },
        { path: '/proposaloversea', element: <ProposalOversea /> },

        { path: '/brand', element: <Brand /> },
        { path: '/representative', element: <Representative /> },

        { path: '/board/noticenews', element: <NoticeNews /> },
        { path: '/board/notice', element: <Notice /> },
        { path: '/board/noticeView', element: <NoticeView /> },
      ]
    },
  ]);
  return(
    <div className='App'>
        <RouterProvider router={router} fallbackElement={<div>Loading...</div>} />
        <div className="btn-quick">
          <div className="btn-top b2b" onClick={() => goToLocation('/proposal')}>
            <div>B2B</div>
            <div>문의</div>
          </div>
          <div className="btn-top top" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
            <img src="https://img.chunhomall.com/images/brand_site/popup-icon-up_30x30.png.png" alt=""></img>
            <div>TOP</div>
          </div>
        </div>
    </div>
    
  );
}

export default App;
